module.exports = __webpack_public_path__ + "img/4-cartoon-content.275d133c.jpg";